<form [formGroup]="editCustomerForm" class="checkout-form">
    <app-checkout-enter-details-form [form]="editCustomerForm" [editCustomer]="true"></app-checkout-enter-details-form>
</form> 